/**
 * Created by admin on 2018/5/22.
 */
import React, { PureComponent } from 'react';
import { Input, Modal } from 'antd';
import './SupportEditModal.less';
import { Btn, RequiredSign } from '../Widgets';
import { FormattedMessage, injectIntl } from 'react-intl';

class RoleEditModal extends PureComponent {
  static defaultProps = {
    visible: false,
    editSupport: {},
    allSupports: []
  };

  constructor() {
    super();
    this.state = {
      supportId: '',
      name: ''
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.visible && nextProps.visible) {
      const { editSupport } = nextProps;
      if (editSupport) {
        this.setState({
          supportId: editSupport.id,
          name: editSupport.name
        });
      }
    }
  }

  render() {
    const { visible, intl } = this.props;
    const { name } = this.state;
    return (
      <Modal
        visible={visible}
        onCancel={this.closeHandle}
        title={intl.formatMessage({ id: 'support_manage_edit_title' })}
        wrapClassName="support-edit-wrapper modal-close-header"
        width={650}
        footer={
          <div className="edit-footer">
            <Btn onClick={this.closeHandle}>
              <FormattedMessage id="support_manage_edit_cancel" />
            </Btn>
            <Btn primary onClick={this.save}>
              <FormattedMessage id="support_manage_edit_ok" />
            </Btn>
          </div>
        }
        closable
      >
        <div className="support-edit">
          <div className="support-name">
            <div className="prefix-title">
              <RequiredSign />
              <FormattedMessage id="support_manage_edit_name" />
            </div>
            <Input
              value={name}
              onChange={e => this.setState({ name: e.target.value })}
            />
          </div>
        </div>
      </Modal>
    );
  }

  save = () => {
    const { supportId, name } = this.state;
    const { dispatch, allSupports } = this.props;
    if (!name) {
      Modal.error({
        content: intl.formatMessage({ id: 'support_manage_edit_empty_name' })
      });
      return;
    }
    for (let support of allSupports) {
      if (name === support.name && supportId !== support.id) {
        Modal.error({
          content: intl.formatMessage({
            id: 'support_manage_edit_duplicate_name'
          })
        });
        return;
      }
    }
    const promise = new Promise((resolve, reject) => {
      dispatch({
        type: 'support/save',
        supportId,
        name,
        resolve,
        reject
      });
    });
    promise.then(
      () => {
        this.closeHandle();
      },
      msg => {
        Modal.error({ content: msg });
      }
    );
  };

  closeHandle = () => {
    const { onCancel } = this.props;
    this.setState({
      supportId: '',
      name: ''
    });
    onCancel && onCancel();
  };
}

export default RoleEditModal;



// WEBPACK FOOTER //
// ./src/components/account/SupportEditModal.js